<script>
//import legoDashboardItem from './legoDashboardItem';
import devMode from './legoDashboardDevMode';

import {h} from 'vue'

export default {
  name: 'legoCoreDashboard',
  components: {devMode},
  emits: ['click', 'evtReleaseMouse', 'evtMoveMouse', 'evtHoldMouse'],
  props: {
    col: {default: 3},
    row: {default: 3},
    gap: {default: 10},
    vsize: null,
    dev: Boolean,
  },
  data() {
    return {};
  },
  methods: {
    genItems() {
      let items = [];
      // 1. append guide line
      if (this.dev) {
        this.appendGuideLine(items);
      }
      // 2. slots..
      const slots = this.$slots.default()[0].children || [];
      for (let i = 0; i < slots.length; i++) {
        let vnode = slots[i];
        // 1. check
        // 1.1 It.. it something wired... -s-)a
        if (!vnode) {
          items.push(vnode);
          continue;
        }
        // 1.2 is not a "LEGO-Dashboard-Item"
        //if( vnode.componentOptions.Ctor.options.name !== 'legoDashboardItem') {continue;}

        // 2. calc and append to items
        const nodeProps = vnode.props;
        vnode.props = Object.assign({}, nodeProps, {
          gap: parseInt(this.gap),
          col: parseInt(this.col),
          row: parseInt(this.row),
          vsize: parseInt(this.vsize),
        })
        // 2.0 modify props... (Can I?)
        // nodeProps.gap = parseInt(this.gap);
        // nodeProps.col = parseInt(this.col);
        // nodeProps.row = parseInt(this.row);
        // nodeProps.vsize = parseInt(this.vsize);

        items.push(vnode);
      }
      return items;
    },
    appendGuideLine(arr) {
      let gap = parseInt(this.gap),
          col = parseInt(this.col),
          row = parseInt(this.row);
      let arg = {
        row, col, gap,
        onEvtReleaseMouse: this.evtReleaseMouse,
        onEvtMoveMouse: this.evtMoveMouse,
        onEvtHoldMouse: this.evtHoldMouse,
        onClick: e => {
          this.$emit('click', e);
        },

      };
      arr.push(h('devMode', arg));
    },

    /* event bypass */
    evtReleaseMouse(_arg) {
      this.$emit('evtReleaseMouse', _arg);
    },
    evtMoveMouse(_arg) {
      this.$emit('evtMoveMouse', _arg);
    },
    evtHoldMouse(_arg) {
      this.$emit('evtHoldMouse', _arg);
    },
  },
  render() {
    const args = {};
    args.class = ['lego-dashboard'];
    if (this.dev) {
      args.class.push('lego-dashboard--dev');
    }
    return h('div', args, this.genItems());
  },
};
</script>